export const formStatus = {
  EDIT: 'Next',
  SAVED: 'Saved',
  SAVING: 'Saving',
};
